export const Bio = {
  name: "Anilesh Prajapati",
  roles: [
    "Machine Learning Engineer",
    "Deep Learning Engineer",
    "Full Stack Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/anilesh-prajapati",
  resume:
    "https://drive.google.com/file/d/1J30oT2w15SlDh_D76LOhJ5fm7RcyBsEz/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/anilesh-prajapati-5b5748239",
  twitter: "https://twitter.com/AnilesPrajapati",
  insta: "https://www.instagram.com/anilesprajapati?igsh=MTE3aWFhOGR3MW45NQ==",
  facebook: "https://www.instagram.com/anilesprajapati?igsh=MTE3aWFhOGR3MW45NQ==",
};

export const skills = [
  {
    title: "Machine Learning",
    skills: [

      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },

      {
        name: "R",
        image:
          "https://www.r-project.org/logo/Rlogo.svg",
      },

      {
        name: "Scikit-learn",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/scikitlearn/scikitlearn-original.svg",
      },

      {
        name: "TensorFlow",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original-wordmark.svg",
      },

      {
        name: "Keras",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/keras/keras-original.svg",
      },

      {
        name: "PyTorch",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original-wordmark.svg",
      },

      {
        name: "pandas",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pandas/pandas-original-wordmark.svg",
      },

      {
        name: "NumPy",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/numpy/numpy-original-wordmark.svg",
      },

      {
        name: "Matplotlib",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/matplotlib/matplotlib-original-wordmark.svg",
      },

      {
        name: "Seaborn",
        image:
          "https://seaborn.pydata.org/_static/logo-wide-lightbg.svg",
      },




    ],
  },
  {
    title: "Deep Learning",
    skills: [

      {
        name: "TensorFlow",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original-wordmark.svg",
      },

      {
        name: "Keras",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/keras/keras-original.svg",
      },

      {
        name: "PyTorch",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original-wordmark.svg",
      },

      {
        name: "OpenCV",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/opencv/opencv-original.svg",
      },

      {
        name: "Hugging Face ",
        image:
          "https://huggingface.co/front/assets/huggingface_logo-noborder.svg",
      },

      {
        name: "Jupyter Notebook",
        image:
          "https://jupyter.org/assets/logos/rectanglelogo-greytext-orangebody-greymoons.svg",
      },

      {
        name: "Google Colab",
        image:
          "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/colabicon.jpg?alt=media&token=4142e8d0-1118-4d2c-8ef2-6d9c397f8ebd",
      },

      {
        name: "TensorBoard",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tensorflow/tensorflow-original.svg",
      },

    ],
  },


  {
    title: "Web Development",
    skills: [


      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },

      {
        name: "Express Js",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg",
      },

      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },

      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },



    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },


      {
        name: "Figma",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg",
      },



      {
        name: "PyCharm",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pycharm/pycharm-original.svg",
      },

      {
        name: "Spyder",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spyder/spyder-original.svg",
      },

      {
        name: "Streamlit",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/streamlit/streamlit-original.svg",
      },

      {
        name: "WordPress",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/wordpress/wordpress-plain.svg",
      },


    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/mercor.jpg?alt=media&token=dd149438-c9c9-4891-b011-2d54283c406e",
    role: "TextBase Titans Hackathon",
    company: "Mercor",
    date: "Sep 2023 - Sep 2023 ",
    desc: "Create a cutting-edge chatbot meeting real-user needs. Use GPT's function calling and our new deployment dashboard for streamlined deployment.",
    skills: [
      "Chatbot Development",
      "Deployment",

    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/thackathoncertificate.JPG?alt=media&token=9f2cac07-62d3-431b-a9b1-e4203e48c1f9",
  },




];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/collegalogo.jpg?alt=media&token=77958d70-9f37-41ab-9ac7-25a46893ff22",
    school: "Siddharth University Kapilvastu, Siddharth Nagar - (U.P.)",
    date: "2023 - 2026",
    grade: "7.71 SGPA",
    desc: "I am currently pursuing a Bachelor of Computer Application  at Kapilvastu, Siddharth Nagar - (U.P.). I have completed 2 semesters and have a CGPA of 7.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the AI Enthusiast Club, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Computer Application - BCA",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/upboardlogo.jpg?alt=media&token=ffeb4639-d01d-4d20-ae1f-086f24a3c533",
    school: "S V I C , Khadda , Kushinagar",
    date: "2019",
    grade: "68%",
    desc: "I completed my class 12 high school education at Sawami Vivekanand I C Khadda, Kushinagar, where I studied Science with Math.",
    degree: "UP Board(XII), Science with Math",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/upboardlogo.jpg?alt=media&token=ffeb4639-d01d-4d20-ae1f-086f24a3c533",
    school: "S V I C , Khadda , Kushinagar",
    date: "2017",
    grade: "84%",
    desc: "I completed my class 10 education at Sawami Vivekanand I C Khadda, Kushinagar, where I studied Science with Math.",
    degree: "UP Board(X), Science with Math",
  },
];

export const projects = [


  {
    id: 10,
    title: "AI-Powered Algorithmic Trading Bot (Continue)",
    date: "May 2024 - Present ",
    description:
      "Designed and deployed AI-powered algorithmic trading bots for Nifty, Bank Nifty, and Bitcoin. Currently, I'm also developing a trading bot for the Forex market. Leveraged AI and machine learning techniques to enhance trading algorithms and decision-making processes. Programmed custom solutions in Excel for comprehensive signal logging, entry/exit prices, and performance metrics. Implemented paper trading strategies to optimize algorithm performance and mitigate financial risk. Bots are actively running, demonstrating ongoing dedication to monitoring and refining trading strategies. Passionate about advancing algorithmic trading capabilities through innovative AI integration and continuous learning.Committed to advancing algorithmic trading effectiveness through innovative AI integration and continuous improvement.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/algotrading.jpeg?alt=media&token=bd420245-47e3-4e84-bd7b-bb4b8b71718e",
    tags: [
      "Python",
      "Fyers API",
      "CoinDCX API",
      "TWS API",
      "Machine Learning",
      "Deep Learning",
      "LSTM",
      "PPO",
      "AWS Cloud",
      "EC2"


    ],
    category: "machine learning, deep learning",
    github: "",
    webapp: "",
  },

  {
    id: 18,
    title: "Credit Risk Modeling Using Machine Learning in Banking",
    date: "",
    description:
      "In the banking world, it is essential to make well-informed credit lending decisions. Our aim is to revolutionize how banks assess which customers, corporate accounts, and companies should receive loans. By utilizing real datasets and the power of machine learning and data science, we seek to refine current credit lending strategies into a more scientific, data-driven approach. We are using two datasets for this project:- CIBIL Dataset- Internal Bank Dataset The dataset contains 88 features and 51, 300 rows.Throughout this project, I have gained valuable insights into the banking industry, including concepts such as Asset vs.Liability, Net Interest Margin(NIM), Gross Non - Performing Assets(GNPA) vs.Net Non - Performing Assets(NNPA), and many more.Currently, many banks rely on traditional methods for lending decisions.However, our project focuses on improving these methods by integrating advanced machine learning models to accurately predict and mitigate credit risks.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/creditriskmodeling.jpg?alt=media&token=5bd5699e-7f91-4171-aec4-f6d21d072360",
    tags: [
      "Python",
      "Scipy",
      "scikit-learn",
      "statsmodels",
      "NumPy",
      "Pandas",
      "Matplotlib"



    ],
    category: "machine learning",
    github: "https://github.com/anilesh-prajapati/Credit-Risk-Modeling-Using-Machine-Learning-in-Banking/tree/main",
    webapp: "https://github.com/anilesh-prajapati/Credit-Risk-Modeling-Using-Machine-Learning-in-Banking/tree/main",
  },

  {
    id: 11,
    title: "Stock Price Prediction",
    date: "",
    description:
      "The goal of this project is to predict future stock prices based on historical data. The model uses RNNs, particularly LSTM networks, to capture temporal dependencies in the stock price data.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/stockpriceprediction.jpg?alt=media&token=b2ccae37-a205-4595-b308-738e8e86d20e",
    tags: [
      "Python",
      "RNN",
      "scikit-learn",
      "Keras",
      "NumPy",
      "Pandas",
      "LSTM",
      "Matplotlib"



    ],
    category: "deep learning",
    github: "https://github.com/anilesh-prajapati/Stock-Price-Prediction",
    webapp: "https://github.com/anilesh-prajapati/Stock-Price-Prediction",
  },


  {
    id: 12,
    title: "Movie Recommender System",
    date: "",
    description:
      "The objective of this project is to create a recommender system that predicts whether a user will like a movie. The model uses Boltzmann Machines, a type of stochastic neural network, to learn user preferences and make recommendations.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/recommendersystem.png?alt=media&token=cc5b883b-f69c-4b04-be07-2db8b62d2b38",
    tags: [
      "Python",
      "Pytorch",
      "scikit-learn",
      "RBM",
      "NumPy",
      "Pandas"




    ],
    category: "deep learning",
    github: "https://github.com/anilesh-prajapati/Recommender-Systems",
    webapp: "https://github.com/anilesh-prajapati/Recommender-Systems",
  },

  {
    id: 13,
    title: "Credit Card Fraud Detection",
    date: "",
    description:
      "The goal of this project is to detect fraudulent credit card transactions using Self-Organizing Maps. SOMs are an unsupervised learning method used to visualize and interpret complex data patterns.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/frauddetection.jpg?alt=media&token=350bffc8-f51b-4b42-8d1e-1af4ae5df9e2",
    tags: [
      "Python",
      "MiniSom",
      "NumPy",
      "Pandas",
      "Matplotlib",
      "Som"





    ],
    category: "deep learning",
    github: "https://github.com/anilesh-prajapati/Credit-Card-Fraud-Detection",
    webapp: "https://github.com/anilesh-prajapati/Credit-Card-Fraud-Detection",
  },

  {
    id: 14,
    title: "Image Recognition",
    date: "",
    description:
      "This project aims to develop a CNN model capable of recognizing images with high accuracy. The model is built using Python, TensorFlow, and Keras, leveraging the power of deep learning for computer vision tasks.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/ImageRecognition.jpeg?alt=media&token=cdef1931-d3b5-4b82-9257-fb4074a5f2b4",
    tags: [
      "Python",
      "CNN",
      "TensorFlow",
      "Keras",






    ],
    category: "deep learning",
    github: "https://github.com/anilesh-prajapati/Image-Recognition",
    webapp: "https://github.com/anilesh-prajapati/Image-Recognition",
  },

  {
    id: 15,
    title: "Churn Modeling",
    date: "",
    description:
      "Customer churn is a critical issue in various industries. This project aims to predict customer churn using advanced machine learning techniques, specifically Artificial Neural Networks. The model is built using Python and R, leveraging libraries like h2O, TensorFlow, NumPy, and Pandas for data processing and model training.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/churmdodeling.jpg?alt=media&token=4e0c5a4d-5f50-4de3-aa39-1432dfc1a18c",
    tags: [
      "Python",
      "ANN",
      "TensorFlow",
      "NumPy",
      "Pandas",
      "R",
      "h2O",


    ],
    category: "deep learning",
    github: "https://github.com/anilesh-prajapati/Churn-Modelling-Problem",
    webapp: "https://github.com/anilesh-prajapati/Churn-Modelling-Problem",
  },

  {
    id: 16,
    title: "Video to Text Generator",
    date: "",
    description:
      "This application takes a video URL as input and utilizes OpenAI's advanced language model, Whisper, to transcribe the video into text. The process is facilitated by PyTorch for model integration and PyTube for fetching and processing video data.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/videototext.jpeg?alt=media&token=e8315915-8402-4b4d-b9fe-5f74593a74cf",
    tags: [
      "Python",
      "OpenAI API",
      "Whisper model",
      "PyTorch",
      "PyTube",



    ],
    category: "machine learning",
    github: "https://github.com/anilesh-prajapati/Video-to-Text-Generator-using-OpenAI-s-Whisper-Model",
    webapp: "https://github.com/anilesh-prajapati/Video-to-Text-Generator-using-OpenAI-s-Whisper-Model",
  },

  {
    id: 17,
    title: "Story Generator and Reviewer",
    date: "",
    description:
      "The program allows users to specify the type of story they want (e.g., fantasy, mystery, romance, cartoon) and provide a starting text prompt. Using OpenAI's powerful language models, it generates a story based on these inputs. After generating the story, the program then generates a review or critique of the story content.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/storyandreview.jpg?alt=media&token=937b64e8-04ff-468e-b20f-040bdb09d8f1",
    tags: [
      "Python",
      "OpenAI API",
      "Gradio ",




    ],
    category: "machine learning",
    github: "https://github.com/anilesh-prajapati/Story-Generator-and-Reviewer-with-OpenAI-API",
    webapp: "https://github.com/anilesh-prajapati/Story-Generator-and-Reviewer-with-OpenAI-API",
  },



  {
    id: 9,
    title: "PDFChatBot",
    date: " ",
    description:
      "PDF Chat Bot App is an innovative web application that enables users to engage in interactive conversations with a chatbot using content extracted from PDF files. This project leverages natural language processing (NLP) and machine learning to create an engaging and insightful experience.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/thm.JPG?alt=media&token=35266040-114c-43f8-91b5-61e7c29b8fdd",
    tags: [
      "Python",
      "LangChain",
      "OpenAI",
      "LLM",
      "Streamlit",
      "Streamlit Cloud "

    ],
    category: "machine learning",
    github: "https://github.com/anilesh-prajapati/PDFChatBotApp",
    webapp: "https://pdfchatbotapp-au6bh2njx8mk4r5wfuylp5.streamlit.app/",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  {
    id: 1,
    title: "Remove Background App",
    date: "",
    description:
      "Photo Background Removal App repository! This app is designed to simplify the process of removing backgrounds from photos using the rembg library and Streamlit framework. Whether you're a professional photographer, a graphic designer, or someone who loves to get creative with their photos, this app has got you covered.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/sdsf.JPG?alt=media&token=196f7071-0e04-4a79-9df2-864a3435a653",
    tags: [
      "Python",
      "rembg",
      "Streamlit ",
      "Streamlit Cloud",

    ],
    category: "machine learning",
    github: "https://github.com/anilesh-prajapati/RemoveBackground",
    webapp: "https://removebackgroundai.streamlit.app/",
  },

  {
    id: 3,
    title: "Netflix Clone",
    date: " ",
    description:
      "This is a Netflix clone created using HTML and CSS, providing users with a glimpse of the popular streaming platform's interface. With its sleek design and intuitive layout, this clone offers a familiar browsing experience for users accustomed to Netflix.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/netflixclone.png?alt=media&token=17896f8d-6518-41bf-8d7b-8b3ca976ffa1",
    tags: [
      "HTML",
      "CSS",
      "Github Pages"


    ],
    category: "web app",
    github: "https://github.com/anilesh-prajapati/Netflix-Clone",
    webapp: "https://anilesh-prajapati.github.io/Netflix-Clone/",
  },

  {
    id: 4,
    title: "UltraEdit Website Clone",
    date: " ",
    description:
      "This is an Ultara website clone created using HTML and CSS, providing users with a glimpse of the modern and professional look of Ultara's official site. With its sleek design, smooth animations, and intuitive layout, this clone offers a polished browsing experience, showcasing the key features and aesthetic appeal of the original Ultara website.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/ultrawebclone.jpg?alt=media&token=ec56f1c6-3a9f-465f-bc80-b69b0bc66525",
    tags: [
      "HTML",
      "CSS",
      "Github Pages"


    ],
    category: "web app",
    github: "https://github.com/anilesh-prajapati/UltraEdit-Website-Clone",
    webapp: "https://anilesh-prajapati.github.io/UltraEdit-Website-Clone/",
  },



  {
    id: 2,
    title: "Brain Tumor Detection",
    date: " ",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/portfolio-website-131ba.appspot.com/o/Image2.png?alt=media&token=024f12a1-84ad-4e4c-8da3-94c4b658d476",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "",
    webapp: "https://brain-tumor.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },


  // {        
  //   id: 8,
  //   title: "Face Recognition",
  //   date: " ",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "",
  //   webapp: "",
  // },
];



